import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a4545f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import ArrowDown from "@/icons/common/arrow-down.vue";
import { SelectItem } from "@/types/select-list";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-list-item',
  props: {
  item: {
    type: Object as PropType<SelectItem>,
    default: () => ({}),
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  isListImage: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:select"],
  setup(__props, { emit }) {

const props = __props;





const select = () => {
  emit("update:select", props.item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["select-list-item", { first: __props.isSelected, image: __props.isListImage }]),
    onClick: select
  }, [
    (__props.isSelected || __props.isListImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.item.image
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass({ first: __props.isSelected })
    }, _toDisplayString(__props.item.name), 3),
    (__props.isSelected)
      ? (_openBlock(), _createBlock(ArrowDown, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})